import React from "react";
import Checkout1 from "../components/Checkout1/index";

const checkout1 = () => {
  return <Checkout1 />;
};

export default checkout1;
